<template>
  <v-container
    fluid
    fill-height
    class="page__login"
    :class="`page__login--${backgroundImage}`"
  >
    <SessionExpiresWarning />
    <LoginAttemptsWarning :attemptsRemaining="attemptsRemaining" :attemptsStep="attemptsStep"/>

    <div class="wrapper">
      <v-layout v-if="loginContainer">
        <div :class="{ login: true, step2: processStep === 'step2' }">
          <img src="@/assets/img/99icon_black.svg" alt="99 Empresas" title="99 Empresas" class="login__brand">
          <LoginForm @toggleForm="toggleForm" @setAttemptsRemaining="setAttemptsRemaining" @toggleStep="toggleStep"/>
        </div>
      </v-layout>

      <v-layout v-if="forgotPasswordContainer">
        <div class="login">
          <img src="@/assets/img/99icon_black.svg" alt="99 Empresas" title="99 Empresas" class="login__brand">
          <ForgotPasswordForm @toggleForm="toggleForm" />
        </div>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Cookies from 'utils/Cookies'
import {
  SESSION_USER,
  SESSION_HEADERS,
  // SESSION_EXPIRES_TIME,
  COST_CENTER_COUNTER,
  SESSION_COMPANY
} from 'utils/constants'

// components
import SessionExpiresWarning from 'components/login/SessionExpiresWarning'
import LoginAttemptsWarning from 'components/login/LoginAttemptsWarning'
import LoginForm from 'components/login/LoginForm'
import ForgotPasswordForm from 'components/login/ForgotPasswordForm'

export default {
  name: 'LoginPage',
  components: {
    SessionExpiresWarning,
    LoginAttemptsWarning,
    LoginForm,
    ForgotPasswordForm
  },
  data () {
    return {
      namespace: 'Views.LoginPage',
      loginContainer: true,
      processStep: 'step1',
      forgotPasswordContainer: false,
      attemptsRemaining: '',
      attemptsStep: ''
    }
  },
  computed: {
    ...mapState('session', ['status']),

    backgroundImage () {
      // return [1, 2, 3, 4, 5, 6][Math.floor(Math.random() * 3)]
      return 2
    }
  },
  methods: {
    ...mapActions({
      clearSelectedCompany: 'company/clearSelectedCompany',
      clearUserClaims: 'userClaims/clear',
      clearCostCenterCounter: 'costCenter/clear'
      // setSessionExpiresTime: 'sessionExpiresTime/set'
    }),

    toggleForm () {
      this.loginContainer = !this.loginContainer
      this.forgotPasswordContainer = !this.forgotPasswordContainer
      this.setAttemptsRemaining('')
    },

    toggleStep () {
      if (this.processStep === 'step1') this.processStep = 'step2'
      else this.processStep = 'step1'
    },

    setAttemptsRemaining (attempt, attemptsStep) {
      this.attemptsRemaining = attempt
      this.attemptsStep = attemptsStep
    },

    resetUserSession () {
      // remove sessions
      Cookies.set(SESSION_USER, '', 0)
      localStorage.removeItem(SESSION_COMPANY)
      localStorage.removeItem(SESSION_HEADERS)
      // localStorage.removeItem(SESSION_EXPIRES_TIME)
      this.$store.state.session.status.loggedIn = false
      this.$store.state.session.user = {}
      this.clearUserClaims()
      this.clearSelectedCompany()
      this.clearCostCenterCounter()
      // this.setSessionExpiresTime(null)

      // remove const center count
      localStorage.removeItem(COST_CENTER_COUNTER)
    }
  },
  created () {
    this.resetUserSession()
  },
  mounted () {
    document.body.classList.add('hide__chat__class')
  }
}
</script>

<style lang="scss">
.wrapper-info__title {

  span {
    background-image: linear-gradient(108deg, #ffdd00, #ffb400);
    border-radius: 40px;
    text-transform: uppercase;
    font-weight: 800;
    font-size: 16px;
    padding: 1px 6px;
    vertical-align: middle;
  }
}

.wrapper-info__list {
  list-style-type: none;
  padding: 0;

  li {
    font-size: 16px;
    margin-bottom: 20px;
    padding-left: 48px;
    position: relative;

    img {
      left: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
